module.exports = __webpack_public_path__ + "static/media/trademc-logo.8a7e0c09.svg";